import { Component } from '@angular/core';

@Component({
    selector: 'app-circular-carousel',
    templateUrl: './circular-carousel.component.html',
    styleUrls: ['./circular-carousel.component.css'],
    standalone: false
})
export class CircularCarouselComponent {

}
